export const API_GATEWAY = {
  PRESIGNED_URL: 'presigned-url',
  GET_AVATAR: 'get-avatar-url',
  GET_AVATAR_IMAGE: 'get-avatar-image',
};
